module.exports = __webpack_public_path__ + "static/media/Fajar-Dirham-Resume.6552fd88.pdf";